// src/vendor/VendorLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  Box, Drawer, List, ListItem, ListItemText, Toolbar, Typography
} from '@mui/material';

const drawerWidth = 240;

export default function VendorLayout() {
  return (
    <Box sx={{ display: 'flex' }}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#0c2546',
            color: 'white',
          },
        }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap>
            Vendor Portal
          </Typography>
        </Toolbar>
        <List>
          <ListItem button component="a" href="/vendor">
            <ListItemText primary="Vendor ledger" />
          </ListItem>
          <ListItem button component="a" href="/vendor/documents">
            <ListItemText primary="Documents" />
          </ListItem>
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}